import FormDrawer, {
  FormDrawerProps,
} from 'components/drawers/form-drawer/form-drawer.component';
import ProductListForm from 'components/forms/product-list-form/product-list-form.component';
import { useProductListForm } from 'components/forms/product-list-form/product-list-form.hooks';
import { useWatch } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { UtilityDrawerHookReturnType } from '../utility-drawer/utility-drawer.hooks';
import i18n from 'i18next';

export type ProductType = 'ITEM' | 'GROUP';

export type ProductsDrawerProduct = {
  category: ProductType;
  id: string;
  label: string;
  product: {
    displayInfoTitlesList: string[];
    externalId: string;
    internalId: string;
    type: ProductType;
  };
};

type ProductsDrawerType = Omit<
  FormDrawerProps,
  'children' | 'onClose' | 'formMethods'
> &
  UtilityDrawerHookReturnType & {
    existingProducts?: ProductsDrawerProduct[];
    amount?: boolean;
    title?: string;
    selectAll?: boolean;
  };

const ProductsDrawer = ({
  open,
  close,
  onValid,
  existingProducts,
  amount,
  selectAll,
  title = i18n.t('drawer.addProductsDrawer.title'),
  ...rest
}: ProductsDrawerType) => {
  const { t } = useTranslation();

  const { form } = useProductListForm(existingProducts);

  const finalOnValid = async data => {
    try {
      onValid?.(data);
      form.reset();
      close();
    } catch (_e) {}
  };

  const cancel = () => {
    form.reset();
    close();
  };

  const products = useWatch({
    control: form.control,
    name: 'products',
  });

  return (
    <FormDrawer
      title={title}
      data-testid="ProductsDrawer"
      submitButtonLabel={t('drawer.addProductsDrawer.submitLabel', {
        products: products.length,
      })}
      {...rest}
      open={open}
      onValid={finalOnValid}
      onClose={cancel}
      cancel={cancel}
      formMethods={form}
    >
      <ProductListForm selectAll={selectAll} />
    </FormDrawer>
  );
};

export default ProductsDrawer;
